import React from 'react';
import { connect } from 'react-redux';
import { Form, Input, Card, Row, Col, Button, Icon } from 'antd';
import { get, post, put } from '../../../utils';
import './style.scss'

const FormItem = Form.Item;

class CategoryTicket extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            code: '',
            name: '',
        }
    }

    getCategoryTicketDetail() {
        const { editId } = this.props
        let url = '/api/crm/administrator/category/ticket/' + editId;
        get(url)
            .then(response => {
                if (response.status >= 400) {
                    throw new Error("Bad response from server");
                }
                this.setState({
                    code: response.code,
                    name: response.name,
                })
            })
            .catch(err => {
                console.log(err.message)
            })
    }

    componentDidMount() {
        if (this.props.editId) {
            this.getCategoryTicketDetail()
        }
    }


    updateCategoryTicket() {
        const { code, name } = this.state
        let data = {
            code: code,
            name: name,
            user: this.props.administratorId
        }
        let url = '/api/crm/administrator/category/ticket/';
        if (this.props.editId) {
            url = '/api/crm/administrator/category/ticket/' + this.props.editId
            put(url, data)
                .then(response => {
                    if (response.status >= 400) {
                        throw new Error("Bad response from server");
                    }
                    this.props.backpage()
                })
                .catch(err => {
                    console.log(err.message)
                })
        } else {
            post(url, data)
                .then(response => {
                    if (response.status >= 400) {
                        throw new Error("Bad response from server");
                    }
                    this.props.backpage()
                })
                .catch(err => {
                    console.log(err.message)
                })
        }
    }

    onClickOk() {
        this.updateCategoryTicket()
    }

    onClickCancel() {
        this.setState({
            code: '',
            name: '',
        })
        this.props.backpage()
    }

    render() {
        const formItemLayout = {
            // labelCol: {
            //     xs: { span: 8 },
            //     sm: { span: 4 },
            // },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        };

        return (
            <div className='categoryticket-page-wrapper' style={{ backgroundColor: '#F9F9F9', height: '90vh' }}>
                <Row className="header-card" >
                    <Col span={12} style={{ textAlign: 'left' }} onClick={() => this.props.backpage()} style={{ cursor: 'pointer' }}>
                        <Icon style={{ fontSize: 25, fontWeight: 500, color: 'rgb(72, 197, 235)' }} type="left" />
                        <span style={{ fontSize: 25, fontWeight: 500, color: 'rgb(72, 197, 235)' }} >Create Category Chat</span>
                    </Col>
                    <Col span={12} style={{ textAlign: 'right' }}>
                        <Button style={{ marginLeft: 2, marginRight: 2, backgroundColor: '#ffffff', color: 'rgb(72, 197, 235)', border: '1px solid rgb(72, 197, 235)' }} onClick={() => this.onClickCancel()}>{'Cancel'}</Button>
                        <Button style={{ marginLeft: 2, marginRight: 2, backgroundColor: 'rgb(72, 197, 235)', color: '#ffffff', border: '1px solid rgb(72, 197, 235)' }} onClick={() => this.onClickOk()} >{'Save'}</Button>
                    </Col>
                </Row>
                <Card className="cardstyle">
                    <Form>
                        <Row gutter={24}>
                            <Col xs={24} sm={24} md={24} lg={12} xl={12} >
                                <FormItem {...formItemLayout} label={'Code'}>
                                    <Input
                                        value={this.state.code}
                                        onChange={(event) => this.setState({ code: event.target.value })}
                                    />
                                </FormItem>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={12} xl={12} >
                                <FormItem {...formItemLayout} label={'Name Category'}>
                                    <Input
                                        value={this.state.name}
                                        onChange={(event) => this.setState({ name: event.target.value })}
                                    />
                                </FormItem>
                            </Col>
                        </Row>
                    </Form>
                </Card>

            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    isAuthenticated: state.login.isAuthenticated,
    administratorId: state.login.id,
})

export default connect(mapStateToProps)(CategoryTicket);

